import React from 'react'
import { ExternAppointmentSchedule } from 'modules/calendar/models/ExternAppointmentSchedule'
import editIcon from 'assets/calendar/edit.svg'
import style from './ScheduleCell.module.css'

interface ScheduleCellProps {
  schedules: ExternAppointmentSchedule[]
  currentDay: Date
  currentHour: string
  weekDays: Date[]
  handleOpenEditSchedule: (schedule: ExternAppointmentSchedule) => void
}

export const ScheduleCell: React.FC<ScheduleCellProps> = ({
  schedules,
  currentDay,
  currentHour,
  weekDays,
  handleOpenEditSchedule,
}) => {
  const filteredSchedules = schedules.filter(
    (item) =>
      item.weekDays.includes(currentDay.getDay()) &&
      parseInt(item.from.split(':')[0]) <= parseInt(currentHour.split(':')[0]) &&
      parseInt(item.to.split(':')[0]) > parseInt(currentHour.split(':')[0])
  )

  return (
    <div className={style.containerEvent}>
      {filteredSchedules.map((schedule) => {
        const duration = parseInt(schedule.to.split(':')[0]) - parseInt(schedule.from.split(':')[0])
        if (duration > 1) {
          if (schedule.from.split(':')[0] !== currentHour.split(':')[0]) return null

          return (
            <div
              key={`${schedule.id}-${schedule.from}-${schedule.to}`}
              className={`${style.scheduleCell}`}
              style={{ minHeight: `${duration * 33}px` }}
            >
              {schedule.from}-{schedule.to}
              <span
                className={style.iconContainer}
                onClick={() => handleOpenEditSchedule(schedule)}
              >
                <img src={editIcon} alt="delete" />
              </span>
            </div>
          )
        }

        return (
          <div
            style={{ minHeight: `${duration * 33}px` }}
            key={`${schedule.from}-${schedule.to}`}
            className={style.scheduleCell}
          >
            {schedule.from}-{schedule.to}
            <span className={style.iconContainer} onClick={() => handleOpenEditSchedule(schedule)}>
              <img src={editIcon} alt="delete" />
            </span>
          </div>
        )
      })}
    </div>
  )
}
